import { useState } from 'react'
import { Download } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { ExportDialog } from '@/components/export/export-dialog'
import { selectSelectedActivity, useActivityStore } from '@/store/activity-store'

/**
 * Toolbar "Export" button (M7) -- only rendered when an activity is
 * selected, same "no placeholder UI" rule `EditMenu` already follows:
 * there is nothing to export otherwise, so the control doesn't exist
 * rather than existing disabled.
 */
export function ExportButton() {
  const hasSelection = useActivityStore((s) => selectSelectedActivity(s) != null)
  const [open, setOpen] = useState(false)

  if (!hasSelection) return null

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="max-sm:w-8 max-sm:px-0"
        onClick={() => setOpen(true)}
      >
        <Download className="h-3.5 w-3.5" aria-hidden="true" />
        {/* Icon-only on phones; the label stays the accessible name. */}
        <span className="max-sm:sr-only">Export</span>
      </Button>
      <ExportDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
